import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { Users, BarChart3, Activity, LogOut } from 'lucide-react';

export default function AdminSidebar() {
    const navigate = useNavigate();

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('role');
        navigate('/login');
    };

    const navClass = ({ isActive }) => `nav-item ${isActive ? 'active' : ''}`;

    return (
        <div className="primary-sidebar glossy" role="navigation" aria-label="Admin">
            <div className="sidebar-brand" title="Blastmate Admin">
                <img src="/logo.png" alt="Blastmate" />
                <span className="sidebar-brand-name">Admin</span>
            </div>
            <nav className="sidebar-nav">
                <NavLink to="/admin" end className={navClass} title="Clients" aria-label="Clients">
                    <span className="active-indicator" aria-hidden="true" />
                    <Users size={18} />
                    <span className="nav-label">Clients</span>
                </NavLink>
                <NavLink to="/admin/stats" className={navClass} title="Platform Stats" aria-label="Platform Stats">
                    <span className="active-indicator" aria-hidden="true" />
                    <BarChart3 size={18} />
                    <span className="nav-label">Stats</span>
                </NavLink>
                <NavLink to="/admin/usage" className={navClass} title="Usage & Costs" aria-label="Usage & Costs">
                    <span className="active-indicator" aria-hidden="true" />
                    <Activity size={18} />
                    <span className="nav-label">Usage</span>
                </NavLink>
            </nav>
            <div className="sidebar-footer">
                <button onClick={logout} className="nav-item" title="Logout" aria-label="Logout">
                    <span className="active-indicator" aria-hidden="true" />
                    <LogOut size={18} />
                    <span className="nav-label">Logout</span>
                </button>
            </div>
        </div>
    );
}
